import { useMemo } from 'react';
import qs from 'qs';
import pick from 'lodash/pick';
import last from 'lodash/last';

/**
 * Custom hook for parsing URL query parameters
 * Memoizes the parsing to prevent repeated operations
 * 
 * @returns {Object} Object containing specific parameters and full query params
 * @returns {string} returns.jwtToken - JWT token from URL
 * @returns {string} returns.audienceToken - Audience token from URL  
 * @returns {string} returns.regMethod - Registration method from URL
 * @returns {Object} returns.queryParams - Full parsed query parameters object
 */
const useAuthQueryParams = () => {
  const parsedParams = useMemo(() => {
    const url = window.location.href;
    const queryString = last(url.split('?')) || '';
    const queryParams = qs.parse(queryString);
    
    // Extract specific parameters that are commonly used
    const { jwtToken } = pick(queryParams, 'jwtToken');
    const { audienceToken } = pick(queryParams, 'audienceToken');
    const { regMethod } = pick(queryParams, 'regMethod');
    const { loginPopup } = pick(queryParams, 'loginPopup');
    const { preview } = pick(queryParams, 'preview');
    
    return {
      jwtToken,
      audienceToken,
      regMethod,
      loginPopup,
      preview
    };
  }, []);
  
  return parsedParams;
};

export default useAuthQueryParams;